module.exports = __webpack_public_path__ + "img/whiteInfo.c28dcba1.svg";